var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3489_45802)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3569 15.8901H8.67988C12.6272 15.8901 15.8324 12.7455 15.8324 8.87298C15.8324 5.00042 12.6272 1.85588 8.67988 1.85588",
    fill: "#AA7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3223 14.1899L12.0461 14.2064L12.9145 13.3156L14.2316 13.2955L13.3223 14.1911V14.1899Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.915 14.5273L11.5943 14.5427L10.8594 14.9911L12.3809 14.8778L12.915 14.5273Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1674 5.91621L13.795 5.83833C13.6543 5.51149 13.1395 4.75633 12.7618 4.33863L14.2316 4.4519C14.542 4.85426 14.9569 5.51031 15.1674 5.91621Z",
    fill: "#F3E9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35701 15.8901C3.40678 15.8901 0.204494 12.7484 0.204494 8.87298C0.204494 4.99754 3.40678 1.85588 7.35701 1.85588C11.3072 1.85588 14.5095 4.99754 14.5095 8.87298C14.5095 12.7484 11.3072 15.8901 7.35701 15.8901Z",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35701 15.8901C3.40678 15.8901 0.204494 12.7484 0.204494 8.87298C0.204494 4.99754 3.40678 1.85588 7.35701 1.85588C11.3072 1.85588 14.5095 4.99754 14.5095 8.87298C14.5095 12.7484 11.3072 15.8901 7.35701 15.8901Z",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86051 8.87319C2.06858 3.2909 7.38456 3.01243 7.30758 3.01243C4.00975 3.01243 1.33373 5.63898 1.33373 8.87319C1.33373 12.1074 4.01096 14.7339 7.30758 14.7339C7.38456 14.7339 1.95913 14.4165 1.86051 8.87319Z",
    fill: "#A67705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3569 14.7823C4.03039 14.7823 1.33373 12.1366 1.33373 8.87312C1.33373 5.60959 4.03039 2.96399 7.3569 2.96399C10.6834 2.96399 13.3801 5.60959 13.3801 8.87312C13.3801 12.1366 10.6834 14.7823 7.3569 14.7823Z",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3569 15.8901H8.67989C12.6272 15.8901 15.8324 12.7455 15.8324 8.87298C15.8324 5.00042 12.6272 1.85588 8.67989 1.85588",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68005 1.85588H7.35698",
    stroke: "#0B1420",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78271 0.921432C9.45435 0.558011 8.75312 0.330283 8.13488 0.497834",
    stroke: "black",
    strokeWidth: 0.78476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22376 1.24693C4.4992 0.843394 5.16194 0.52481 5.79822 0.609766",
    stroke: "black",
    strokeWidth: 0.78476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89031 9.53734C8.89031 9.53734 8.01233 10.0471 7.08263 9.981C6.15294 9.91492 5.32307 9.61758 5.32307 9.61758C5.32307 9.61758 5.16191 10.781 5.81498 11.8429C6.46805 12.9049 7.06219 13.0972 7.67798 12.9957C8.29376 12.8943 9.03944 12.2193 9.29321 11.1503C8.87828 10.7763 8.67382 10.0978 8.8879 9.53734H8.89031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91949 9.50691C7.82142 10.0851 6.55617 10.124 5.29092 9.68862C5.29934 10.0013 5.31257 10.2821 5.3691 10.5712C5.88746 11.1057 7.82383 11.0951 8.83771 10.3836C8.74029 10.1016 8.79802 9.84791 8.91949 9.50691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42192 12.3267C7.4989 12.1651 7.61076 11.9621 7.94514 11.9019C8.39258 11.8217 8.71613 12.1308 8.71613 12.1308C8.71613 12.1308 8.47557 12.814 7.62399 12.9344C6.75316 13.0583 6.4681 12.3833 6.4681 12.3833C6.4681 12.3833 6.52944 12.1485 6.82533 12.0199C7.04063 11.9267 7.30645 11.9609 7.55543 12.0954",
    fill: "#FF7EB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42192 12.3267C7.4989 12.1651 7.61076 11.9621 7.94514 11.9019C8.39258 11.8217 8.71613 12.1308 8.71613 12.1308C8.71613 12.1308 8.47557 12.814 7.62399 12.9344C6.75316 13.0583 6.4681 12.3833 6.4681 12.3833C6.4681 12.3833 6.52944 12.1485 6.82533 12.0199C7.04063 11.9267 7.30645 11.9609 7.55543 12.0954",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.327 8.87326C10.7773 8.46736 9.59735 8.53697 9.07293 9.2473C8.22135 10.3989 9.58291 11.7016 10.491 11.8998",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91949 9.50681C7.55803 10.2596 6.10997 10.1369 4.58493 9.24722",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29913 11.1516C9.11512 11.8997 8.52579 12.9676 7.46741 12.9959C5.87261 13.0395 5.16662 10.6867 5.3338 9.62362",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23381 8.72442C5.29258 8.72442 4.52957 7.78197 4.52957 6.61941C4.52957 5.45684 5.29258 4.5144 6.23381 4.5144C7.17504 4.5144 7.93805 5.45684 7.93805 6.61941C7.93805 7.78197 7.17504 8.72442 6.23381 8.72442Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57819 8.23244C7.4134 8.06843 7.0694 7.7581 6.6388 7.69557C6.13483 7.62241 5.67657 7.7817 5.53223 8.16872C5.34459 8.67373 5.75354 9.27668 6.38742 9.43716C6.68451 9.51267 7.03933 9.49969 7.34003 9.36282",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57819 8.23244C7.4134 8.06843 7.0694 7.7581 6.6388 7.69557C6.13483 7.62241 5.67657 7.7817 5.53223 8.16872C5.34459 8.67373 5.75354 9.27668 6.38742 9.43716C6.68451 9.51267 7.03933 9.49969 7.34003 9.36282",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67509 8.72442C7.73387 8.72442 6.97086 7.78197 6.97086 6.61941C6.97086 5.45684 7.73387 4.5144 8.67509 4.5144C9.61632 4.5144 10.3793 5.45684 10.3793 6.61941C10.3793 7.78197 9.61632 8.72442 8.67509 8.72442Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60762 5.81484C8.17461 5.81484 7.82219 6.24906 7.82219 6.78475C7.82219 7.32044 8.17341 7.75466 8.60762 7.75466C9.01657 7.75466 9.32569 7.3346 9.35455 7.08681L8.66295 6.77413L9.34253 6.44257C9.286 6.15112 8.99011 5.81484 8.60762 5.81602V5.81484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22255 5.66014C5.78954 5.66014 5.43712 6.09436 5.43712 6.63005C5.43712 7.16574 5.78834 7.59996 6.22255 7.59996C6.6315 7.59996 6.94062 7.1799 6.96948 6.93212L6.27788 6.61943L6.95745 6.28787C6.90092 5.99642 6.60503 5.66014 6.22255 5.66132V5.66014Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3489_45802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenCoin);
export default __webpack_public_path__ + "static/media/brokenCoin.a6fd2541865e72252a605bb015718b90.svg";
export { ForwardRef as ReactComponent };